module.exports = __webpack_public_path__ + "static/media/5.question.686b52f5.mp4";